import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { useUIStore } from '../../lib/uiStore';
import { navGroups } from './navConfig';
import { CircuitBoard, Zap } from 'lucide-react';

export function Sidebar() {
  const collapsed = useUIStore((s) => s.sidebarCollapsed);

  return (
    <aside
      className={cn(
        'h-full flex flex-col bg-surface-raised/78 backdrop-blur-2xl border border-border rounded-[30px] shadow-panel',
        'transition-all duration-200 ease-decelerate flex-shrink-0 overflow-hidden',
        collapsed ? 'w-[56px]' : 'w-[240px]'
      )}
    >
      {/* Logo */}
      <div className="flex items-center gap-2.5 px-4 h-16 border-b border-border flex-shrink-0">
        <div className="h-8 w-8 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center flex-shrink-0 shadow-card">
          <CircuitBoard className="h-4 w-4 text-white" />
        </div>
        {!collapsed && (
          <span className="text-base font-semibold text-content tracking-[-0.04em] whitespace-nowrap">
            ElectroPLM
          </span>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-4">
        {navGroups.map((group) => (
          <div key={group.label}>
            {!collapsed && (
              <p className="px-2 mb-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-content-muted">
                {group.label}
              </p>
            )}
            <div className="space-y-0.5">
              {group.items.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      cn(
                        'flex items-center gap-2.5 rounded-2xl transition-all duration-150',
                        collapsed ? 'px-2 py-2.5 justify-center' : 'px-3 py-2.5',
                        isActive
                          ? 'bg-primary-500/12 text-primary-600 font-semibold shadow-subtle'
                          : 'text-content-secondary hover:bg-surface-overlay/90 hover:text-content'
                      )
                    }
                    title={collapsed ? item.label : undefined}
                  >
                    <Icon className="h-4 w-4 flex-shrink-0" />
                    {!collapsed && (
                      <span className="text-sm whitespace-nowrap">{item.label}</span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      {/* Status footer */}
      <div className="px-3 py-3 border-t border-border flex-shrink-0">
        <div className={cn('flex items-center gap-2', collapsed && 'justify-center')}>
          <span className="relative flex h-2 w-2 flex-shrink-0">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success-500 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-success-500" />
          </span>
          {!collapsed && (
            <span className="text-xs text-content-muted">System Operational</span>
          )}
        </div>
      </div>
    </aside>
  );
}
